export default __webpack_public_path__ + "static/media/04.9c8f659e.jpg";